<template>
  <el-card shadow="never" :body-style="{padding : this.padding + 'px'}">
    <el-tag
      :key="index"
      v-for="(tag, index) in operationUsers"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
      type="plain"
    >
      {{ tag }}
    </el-tag>
    <el-input
      class="input-new-tag"
      v-show="operatorNameInputVisible"
      v-model="operatorNameInput"
      ref="saveTagInput"
      size="small"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
      placeholder="请输入姓名"
      :style="
        operationUsers.length === 0 ? 'margin-bottom:10px;' : ''
      "
    >
    </el-input>
    <div>
      <el-button
        class="button-new-tag"
        size="small"
        @click="showOperatorNameInput"
        >手动录入</el-button
      >
      <el-button class="button-new-tag" size="small" @click="showEmps = true"
        >添加员工</el-button
      >
      <el-button
        v-show="operationUsers.length > 0"
        class="button-new-tag"
        size="small"
        @click="operationUsers = []"
        >清空</el-button
      >
      <employee :show.sync="showEmps" @change="changeEmp"></employee>
    </div>
  </el-card>
</template>

<script>
import Employee from "@/components/Employee.vue";
export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    padding:{
        type:Number,
        default:10
    }
  },
  components: { Employee },
  data() {
    return {
      operatorNameInputVisible: false,
      operatorNameInput: "",
      isShowDialog: false,
      showEmps: false,
      operationUsers: this.value,
    };
  },
  watch:{
    value:{
        handler(val){
            this.operationUsers = val
        }
    }
  },
  methods: {
    changeEmp(emps) {
    //   const operationUsers = this.operationUsers.concat(
    //     emps.map((item) => item.employeeName)
    //   );
    //   const uniqueArray = operationUsers.reduce((acc, cur) => {
    //     if (!acc.includes(cur)) {
    //       acc.push(cur);
    //     }
    //     return acc;
    //   }, []);
      emps.map(emp =>{
        if(!this.operationUsers.includes(emp.employeeName)){
            this.operationUsers.push(emp.employeeName)
        }
      })
    },
    showOperatorNameInput() {
      this.operatorNameInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.operationUsers.splice(
        this.operationUsers.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let operatorNameInput = this.operatorNameInput;
      if (operatorNameInput) {
        this.operationUsers.push(operatorNameInput);
      }
      this.operatorNameInputVisible = false;
      this.operatorNameInput = "";
    }
  },
};
</script>

<style scoped lang="less">
.el-card {
  border: none;
  /deep/ .el-card__body {
    
  }
}

.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 170px;
  border: 1px solid #dcdfe6;
}
</style>